import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from './App.vue';
import router from './router';
// import './registerServiceWorker';
import CONSTANTS from './constants';

const Rollbar = require('vue-rollbar');

Vue.config.productionTip = false;

// TODO: https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-v3-badge-what-is-allowed
Vue.use(VueReCaptcha, {
  siteKey: CONSTANTS.GOOGLE_RECAPTCHA_API,
  loaderOptions: {
    autoHideBadge: false,
  },
});

Vue.use(Rollbar, {
  accessToken: 'eb59d6fb717243c3afb286a1180416db',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  source_map_enabled: true,
  environment: 'production',
  payload: {
    client: {
      javascript: {
        code_version: '1.0',
      },
    },
  },
});

// Create Global Filter
Vue.filter('snippet', (val) => {
  if (!val || typeof (val) !== 'string') return '';
  const newVal = val.slice(0, 50);
  return newVal;
});

/* Vue.config.errorHandler = (err) => {
  console.log('Exception: ', err);
  Vue.rollbar.error(err);
}; */

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
